import { FC } from 'react';

interface CheckIconProps {
  width?: string;
  height?: string;
  color?: string;
}

export const CheckIcon: FC<CheckIconProps> = ({ width = '16', height = '16', color = '#000' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16" fill="none">
      <path
        d="M13.3334 4L6.00002 11.3333L2.66669 8"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
